// @flow

export * from './actions';
export * from './common';
// current node process
export const IS_DEVEL = process.env.NODE_ENV !== 'production';

// routes
export const ROOT_ROUTE = '/';
